import { render } from "./SelectField.vue?vue&type=template&id=be86f624"
import script from "./SelectField.vue?vue&type=script&lang=ts"
export * from "./SelectField.vue?vue&type=script&lang=ts"
script.render = render

export default script